"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const GeoJSON_1 = require("./GeoJSON");
const mongoose = tslib_1.__importStar(require("mongoose"));
const schoolWithDistance_1 = require("./subSchemas/schoolWithDistance");
const blockGroupSchema = new mongoose.Schema({
    geoId: {
        type: String,
        index: true,
        trim: true,
        unique: true
    },
    blockGroup: {
        type: String,
        index: true,
        trim: true
    },
    county: {
        type: String,
        index: true,
        trim: true
    },
    tract: {
        type: String,
        trim: true
    },
    centLon: {
        type: Number,
        index: true
    },
    centLat: {
        type: Number,
        index: true
    },
    state: { type: mongoose.Schema.Types.ObjectId, ref: 'State', index: true },
    zip: { type: mongoose.Schema.Types.ObjectId, ref: 'Zip', index: true },
    cbsa: { type: mongoose.Schema.Types.ObjectId, ref: 'Cbsa', index: true },
    airbnbListings: [
        { type: mongoose.Schema.Types.ObjectId, ref: 'AirbnbListing' }
    ],
    broadbandFilings: [
        { type: mongoose.Schema.Types.ObjectId, ref: 'BroadbandFiling' }
    ],
    crimes: [{ type: mongoose.Schema.Types.ObjectId, ref: 'Crime' }],
    blocks: [{ type: mongoose.Schema.Types.ObjectId, ref: 'Block' }],
    assignedSchools: [schoolWithDistance_1.schoolWithDistanceSchema],
    nearbySchools: [schoolWithDistance_1.schoolWithDistanceSchema],
    featureCollection: GeoJSON_1.FeatureCollection
}, {
    timestamps: true
});
const v1BlockGroupModel = mongoose.model('BlockGroup', blockGroupSchema);
exports.v1BlockGroupModel = v1BlockGroupModel;
//# sourceMappingURL=BlockGroup.model.js.map